import { SET_CART_LIST, RESET_CART_LIST } from '../mutation-types';

export default {
  [SET_CART_LIST](state, payload) {
    state.cartList = payload;
  },
  [RESET_CART_LIST](state, payload) {
    if (payload) {
      state.cartList = {
        status: 0,
        data: [],
      };
    } else {
      state.cartList.status = 0;
    }
  },
};
